import type { AppStartListening } from "types/AppStartListening";
import { messagesActions } from "features/messages/store/slice";
import { DossierClientMethodNames } from "features/messages/hubs/sections/DossierSection";
import { MessageArgsToType } from "features/messages/helpers";
import { caseExportsActions } from "./slice";
import { DossierExport } from "types/DossierExport";
import { enqueueSnackbar } from "notistack";
import { DossierExportStatus } from "types/DossierExportStatus";

// listeners
export const addCaseExportsListeners = (startListening: AppStartListening) => {
    startListening({
        predicate: (action) => {
            return (
                messagesActions.messageReceived.match(action) &&
                action.payload.messageType ===
                    DossierClientMethodNames.DossierExportChanged
            );
        },
        effect: async (action, listenerApi) => {
            if (messagesActions.messageReceived.match(action)) {
                const dossierExportChanged = MessageArgsToType<DossierExport>(
                    action.payload.args,
                );

                listenerApi.dispatch(
                    caseExportsActions.updateDossierExport({
                        dossierExportChanged,
                    }),
                );

                // Notify users about the completed dossier export
                if (
                    dossierExportChanged.status ===
                    DossierExportStatus.Completed
                ) {
                    enqueueSnackbar(
                        `Export for case '${dossierExportChanged.name}' completed.`,
                        {
                            variant: "info",
                        },
                    );
                }
            }
        },
    });
};
